// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2tiL3","colMin":"styles_colMin__1YmoY","colCheckbox":"styles_colCheckbox__2Wmgt"};